import { NavBar, AutoCenter, ImageUploader, Avatar, ActionSheet } from 'antd-mobile'
import QRCode from "react-qr-code";

import { 
    BodyView,
    InputView,
    ButtonView,
    NavBarTitleView,
    DividerOptionView
} from "../factory/ViewUtil";

import { 
    DownFill,
    AddOutline,
    ClockCircleOutline
} from 'antd-mobile-icons';
import { BigDecimalZero, CopyToClipboard, DecimalZero, FullURL, ToastClear, ToastContent, ToastLoading } from '../factory/FactoryUtil';
import React, { useEffect, useRef, useState } from 'react';
import { PostRecharge, RequestWallet } from '../../NetworkFactory';


let requestDone = false
const RechargeViewController = ({goback}) => {

    const [base64, seBase64] = useState('')
    const input = useRef(null)
    const openPhoto = () => {
        const nativeInput = input.current?.nativeElement
        if (nativeInput) {
            nativeInput.click()
        }
    };
    const handerPhoto = (file) => {
        return new Promise(() => {
            const reader = new FileReader();
            reader.onload = (e) => {
                seBase64(e.target.result);
            };
            reader.readAsDataURL(file);
        });
    };

    const selectSymbol = () => {
        let actions = []
        Object.keys(dataSource).forEach(item => {
            actions.push({
                key : item,
                text : item,
                onClick : () => {
                    setSymbol(item)
                    setTypeidx(0)
                    handler.close()
                }
            })
        })
        
        const handler = ActionSheet.show(
            {
                extra : <div style={{textAlign : 'center'}}><div style={{color : '#000', fontSize : '18px', marginBottom : '6px'}}>Please select currency</div><div>Recharge channel</div></div>,
                cancelText : 'Cancel',
                actions : actions
            }
        )
    }

    // # 提交
    const submit = () => {

        if(typeof symbol !== 'string') {
            ToastContent('Invalid currency or protocol code')
            return
        }

        const in_address = dataSource[symbol][typeidx].address || ''
        if(in_address.length === 0) {
            ToastContent('Invalid recharge address')
            return
        }

        const number = BigDecimalZero(rechargeQuantity)
        if(number.comparedTo(DecimalZero()) <= 0) {
            ToastContent('Invalid recharge quantity')
            return
        }
        
        if(rechargeAddress.length < 6) {
            ToastContent('Your recharge wallet address is invalid')
            return
        }

        if(rvie && base64.length <= 0) {
            ToastContent('Please upload recharge screenshot')
            return
        }
        requestDone = false
        ToastLoading('Requesting...')
        const data = {
            symbol : symbol,
            code : dataSource[symbol][typeidx].code || '',
            number : number.toString(),
            address : rechargeAddress,
            in_address : in_address,
            voucher : base64 ?? ''
        }
        PostRecharge(data).then(() => {
            requestDone = true
            ToastContent('Submitted for review')
            goback()

        }).catch(()=> {
            requestDone = true
            ToastContent('Error')
        })
    }

    const showErrorAndBack = () => {
        ToastContent('No recharge channel found')
        goback()
    }

    const onChange = () => {
        setRechargeAddress('')
        setTypeidx(typeidx === 0 ? 1 : 0)
    }

    const copyAddress = () => {
        try {
            CopyToClipboard(dataSource[symbol][typeidx].address)
        }
        catch  {}
    }
    const [rechargeQuantity, setRechargeQuantity] = useState('')
    const [rechargeAddress, setRechargeAddress] = useState('')
    const [rvie, setRvie] = useState(true);

    const [dataSource, setDataSource] = useState({});
    const [symbol, setSymbol] = useState(null);
    const [typeidx, setTypeidx] = useState(0);
    
    useEffect(()=> {
        ToastLoading('Loading...')
        RequestWallet().then(response => {
            requestDone = true
            ToastClear()
            const data = response.data.data || []
            setRvie(response.data.rvie === 'true')
            let mapData = {}
            // # 效验数据
            let newData = []
            data.forEach(item => {
                const {name, in_address, protocol_code, modificationDate, data} = item
                if(name && in_address && protocol_code && modificationDate) {
                    newData.push({
                        name : name,
                        data : data,
                        address : in_address,
                        code : protocol_code,
                        md : modificationDate,
                        url : FullURL(item.url)
                    })
                    mapData[name] = []
                }
            })

            // # 排序
            const sortData = [...newData].sort((a, b) => {
                return a.md - b.md
            })

            // # 合并数据
            sortData.forEach(item => {
                let itemData = mapData[item.name] 
                itemData.push(item)
            })
            const keys = Object.keys(mapData)
            if(keys.length === 0) {
                showErrorAndBack()
                return
            }
            setDataSource(mapData)
            setSymbol(keys[0])
            
        }).catch(() => {
            requestDone = true
            showErrorAndBack()
        })
        return () => {
            if(!requestDone) {
                ToastClear()
            }
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const openHistory = () => {
        let actions = []
        try {
            const data = dataSource[symbol][typeidx].data??[]
            data.forEach(item => {
                actions.push({
                    key : item,
                    text : <div style={{wordBreak : 'break-all'}}>{item}</div>
                })
            })
        } catch {}
        if(actions.length === 0) {
            ToastContent('No address record')
            return
        }
        const handler = ActionSheet.show(
            {
                extra : <div style={{textAlign : 'center'}}><div style={{color : '#000', fontSize : '18px', marginBottom : '6px', color : '#666'}}>Historical records</div></div>,
                cancelText : 'Cancel',
                actions : actions,
                onAction : (item, index) => {
                    handler.close()
                    setRechargeAddress(item.key)
                }
            }
        )
    }

    return(
        <>
             <div className='fixed-nav-bar'>
                <NavBar onBack = {goback} right = {<div onClick={copyAddress}>Copy Address</div>}>
                    {
                        symbol ? <NavBarTitleView onClick={selectSymbol} src={dataSource[symbol][0].url} icon={<DownFill fontSize={10}/>}>{symbol}</NavBarTitleView> : ''
                    }
                </NavBar>
            </div>
            {
               symbol ? (<BodyView style={{padding : '0 10px', paddingTop : '52px', textAlign : 'center'}}>
                    <div style={{
                        width : '200px', 
                        height : '200px',
                        margin : 'auto', 
                        marginTop : '20px'}}>
                        <QRCode value={dataSource[symbol][typeidx].address} style={{width : '100%', height : '100%'}}></QRCode>
                    </div>

                    <AutoCenter className="tipHeaderTitle" style={{fontSize : '14px', textAlign : 'center'}}>
                        {dataSource[symbol][typeidx].address}
                    </AutoCenter>

                    <div style={{marginTop : '20px'}}></div>
                    {
                        dataSource[symbol].length === 2 ?  <DividerOptionView onChange={onChange} left={typeidx===0} leftText={dataSource[symbol][0].code} rightText={dataSource[symbol][1].code}/> : ''
                    }

                    <AutoCenter className="tipHeaderTitle" style={{marginBottom : '25px'}}>
                        The amount of recharge should not be too small
                    </AutoCenter>

                    <InputView title = "Recharge quantity" value={rechargeQuantity} onChange={val => {setRechargeQuantity(val)}}/>
                    <div style={{height : '20px'}} ></div>
                    <InputView title = "Wallet Address" value={rechargeAddress} onChange={val => {setRechargeAddress(val)}} right={
                        <div style={{marginTop : 4, lineHeight : 0}}><ClockCircleOutline onClick={openHistory}/></div>
                    }/>

                    <AutoCenter className="tipHeaderTitle">
                        {rvie && <span>Upload Recharge screenshot</span>}
                    </AutoCenter>
                    
                    { rvie && <div style={{marginBottom : '20px'}}>
                        <ImageUploader
                            ref={input}
                            accept = 'image/jpeg,image/jpg,image/png'
                            beforeUpload={handerPhoto}
                            maxCount={1} 
                            columns={0}
                            onPreview={false}
                            style={{display : 'none'}}
                        />
                        <div onClick={()=> {openPhoto()}} style={{width : '100px', height : '100px'}}>
                            <Avatar fallback={<div style={{height : '100px', fontSize : '50px', display : 'flex', justifyContent : 'center', alignItems : 'center', color : '#D8D8D8'}}><AddOutline/></div>} 
                            src={base64} 
                            style={{width : '100%', height : '100%', background : '#F6F6F6', borderRadius : '10px'}}/>
                        </div>
                    </div>}
                    <ButtonView onClick={()=>{submit()}}>Submit</ButtonView>
                    <AutoCenter className="tipHeaderTitle" style={{marginBottom : '50px'}}>
                        Please do not recharge any non <b>{symbol}</b> assets to the above address, otherwise the assets will not be recoverable.
                    </AutoCenter>
                </BodyView>) : ''
            }
        </>
    );
}
export default React.memo(RechargeViewController)